package com.checkin.host.util

import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.khronos.webgl.get

fun arrayBufferToByteArray(buffer: ArrayBuffer): ByteArray {
    val int8 = Int8Array(buffer)
    return ByteArray(int8.length) { i -> int8[i] }
}

fun pngBytesToObjectUrl(bytes: ByteArray): String = js(
    """
    (function(pngBytes) {
        var blob = new Blob([pngBytes], {type: 'image/png'});
        return URL.createObjectURL(blob);
    })
    """
)(bytes) as String

fun revokeObjectUrl(url: String) {
    js("(function(u) { URL.revokeObjectURL(u); })")(url)
}
